"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _productManage = require("@/api/_homeCloudPlatform/mall/productManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  name: '',
  product_type: '',
  usage: '',
  notice: ''
};

// const phoneValidator = (rule, value, callBack) => {
//   const reg = /^[1][0-9]{10}$/
//   if (value) {
//     if (!reg.test(value)) {
//       callBack('请输入正确的联络人手机号')
//     } else {
//       callBack()
//     }
//   } else {
//     callBack()
//   }
// }
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      return {
        name: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        product_type: [{
          required: true,
          message: '请输入产品种类',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        usage: [{
          max: 150,
          message: '输入长度不能超过150位',
          trigger: 'blur'
        }],
        notice: [{
          required: true,
          message: '请输入注意事项',
          trigger: 'blur'
        }, {
          max: 150,
          message: '输入长度不能超过150位'
        }]
        // contact_phone: [
        //   { required: true, message: '请输入联络人手机号', trigger: 'blur' },
        //   { validator: phoneValidator },
        //   { max: 11, message: '输入长度不能超过11位' }
        //   { type: 'number', message: '排序必须为数字值' }
        // ],
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u4EA7\u54C1");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依創建時間遞減
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20,
        product_status: ''
      },
      dialogVisible: false,
      dialogType: 'view',
      // 狀態選項
      statusOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: '上架'
      }, {
        key: 2,
        display_name: '下架'
      }]
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _productManage.getProductList)(this.handleQuery()).then(function (res) {
        _this.tableData = res || {};
        _this.listLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      var _this2 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this3 = this;
      this.formModel = Object.assign({}, scope.row);
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;
      this.formModel = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this5 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _productManage.deleteProduct)(scope.row.id);
            case 2:
              _this5.getList();
              _this5.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this6.dialogType === 'edit';
                  if (isEdit) {
                    (0, _productManage.updateProduct)(_this6.formModel.id, _this6.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this6.dialogType === 'add') {
                    (0, _productManage.createProduct)(_this6.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.product_status === '' || query.product_status === 0) {
        query.product_status = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    }
  }
};